import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

const ErrorPage = () => {
  const navigate = useNavigate();
  
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] px-4 py-16 text-center">
      <h1 className="text-4xl font-bold text-status-error-light-text dark:text-status-error-dark-text">404</h1>
      <h2 className="mt-4 text-2xl font-bold text-ui-light-text-primary dark:text-ui-dark-text-primary">Page Not Found</h2>
      <p className="mt-2 text-ui-light-text-secondary dark:text-ui-dark-text-secondary">Sorry, we couldn't find the page you're looking for.</p>
      <div className="mt-6">
        <button
          onClick={() => navigate(-1)}
          className="px-4 py-2 mr-4 text-sm font-medium text-primary-700 dark:text-primary-400 bg-primary-100 dark:bg-primary-900/30 rounded-md hover:bg-primary-200 dark:hover:bg-primary-800/50 transition-colors"
        >
          Go Back
        </button>
        <Link
          to="/"
          className="px-4 py-2 text-sm font-medium text-white dark:text-ui-dark-text-primary bg-primary-600 dark:bg-primary-700 rounded-md hover:bg-primary-700 dark:hover:bg-primary-600 transition-colors"
        >
          Go Home
        </Link>
      </div>
    </div>
  );
};

export default ErrorPage;